import { useCallback } from 'react';
import { Image } from '@components/common/Image';
import { UiKitButton } from '@components/common/ui-kit-button';
import { ButtonGroup } from '@features/Unsubscribe/components/ButtonGroup';
import { Container } from '@features/Unsubscribe/components/Container';
import { Title } from '@features/Unsubscribe/components/Title';
import { useUnsubscribeAnalytics } from '@features/Unsubscribe/hooks/use-unsubscribe-analytics';
import type { TpWizardSteps } from '@features/Unsubscribe/types';
import { WIZARD_STEPS } from '../../сonstants';
import styles from './LotsOfNew.module.scss';
const CARDS = [{
  title: 'Exclusive types of massage',
  subtitle: 'New content sections',
  image: 'exclusive-types.webp',
  background: '#F6D187'
}, {
  title: 'AI-powered trainings',
  subtitle: 'Maximum efficiency',
  image: 'ai-powered.webp',
  background: '#B6DFC9'
}, {
  title: 'Beauty support',
  subtitle: 'Personal assistant',
  image: 'beauty-support.webp',
  background: '#FFCEF7'
}];
export const LotsOfNew = (props: TpWizardSteps) => {
  const {
    defaultEventOptions,
    trackUnsubscribeEvent
  } = useUnsubscribeAnalytics();
  const {
    wizard,
    featureFlags
  } = props;
  const cancelNextStep = featureFlags?.pause ? WIZARD_STEPS.GIFT_PREMIUM : WIZARD_STEPS.SAD;
  const handleNext = useCallback(async () => {
    trackUnsubscribeEvent('cancel_lots_of_new_chosen', {
      variant: '1- keep subscription'
    });
    wizard.goToStep(WIZARD_STEPS.HAPPY);
  }, [trackUnsubscribeEvent, wizard]);
  const handleCancel = useCallback(async () => {
    trackUnsubscribeEvent('cancel_lots_of_new_chosen', {
      variant: '2-cancel'
    });
    wizard.goToStep(cancelNextStep);
  }, [cancelNextStep, trackUnsubscribeEvent, wizard]);
  return <Container className={styles.container} eventOnMounted="cancel_lots_of_new_opened" eventOptions={defaultEventOptions} data-sentry-element="Container" data-sentry-component="LotsOfNew" data-sentry-source-file="index.tsx">
      <Title className={styles.title} data-sentry-element="Title" data-sentry-source-file="index.tsx">
        Lots of new content <br /> is coming
      </Title>
      <div className={styles.cardsContainer}>
        {CARDS.map(card => <div key={card.title} className={styles.card} style={{
        background: `${card.background}`
      }}>
            <div className={styles.cardContent}>
              <h3 className={styles.cardTitle}>{card.title}</h3>
              <p className={styles.cardSubtitle}>{card.subtitle}</p>
            </div>
            <div className={styles.imageWrapper}>
              <Image src={card.image} alt={card.title} width={112} height={92} />
            </div>
          </div>)}
      </div>

      <ButtonGroup className={styles.buttonGroup} data-sentry-element="ButtonGroup" data-sentry-source-file="index.tsx">
        <UiKitButton color="pure" onClick={handleCancel} className={styles.button} data-sentry-element="UiKitButton" data-sentry-source-file="index.tsx">
          Cancel subscription
        </UiKitButton>
        <UiKitButton onClick={handleNext} className={styles.button} fullWidth data-sentry-element="UiKitButton" data-sentry-source-file="index.tsx">
          Keep my subscription
        </UiKitButton>
      </ButtonGroup>
    </Container>;
};